// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  standalone: false,
})
export class CapitalizePipe implements PipeTransform {
  transform(input: string, all = false): string {
    if (!input) {
      return '';
    }

    if (all) {
      return input
        .split(' ')
        .map(word => this.capitalizeWord(word))
        .join(' ');
    }

    return this.capitalizeWord(input);
  }

  private capitalizeWord(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
}
